import React, { useRef } from 'react';
import Modal from './Modal';
import BeGatewayPayment from './BeGatewayPayment';

/**
 * Payment Modal component that displays BeGateway payment form in a modal
 * 
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the payment modal is open
 * @param {function} props.onClose - Function to call when the modal is closed
 * @param {string} props.orderId - Unique order identifier
 * @param {number} props.amount - Payment amount
 * @param {string} props.currency - Currency code (EUR, USD, etc)
 * @param {string} props.description - Payment description
 * @param {Object} props.customer - Customer information
 * @param {function} props.onSuccess - Callback for successful payment
 * @param {function} props.onError - Callback for payment errors
 */
const PaymentModal = ({
    isOpen,
    onClose,
    orderId,
    amount,
    currency = 'EUR',
    description = 'Star Map Purchase',
    customer = {},
    onSuccess,
    onError
}) => {
    const paymentRef = useRef(null);

    // Custom success handler to close modal
    const handleSuccess = (data) => {
        if (onSuccess) {
            onSuccess(data);
        }
        onClose();
    };

    // Custom error handler to close modal
    const handleError = (error) => {
        if (onError) {
            onError(error);
        }
        onClose();
    };

    // Format amount for display (cents to whole currency)
    const formatAmount = (amountInCents) => {
        return (amountInCents / 100).toFixed(2);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Complete Your Payment"
            size="lg"
            showCloseButton={false}
        >
            <div className="payment-modal-content">

                {/* BeGateway component with button hidden */}
                <div className="w-full mx-auto">
                    <BeGatewayPayment
                        ref={paymentRef}
                        orderId={orderId}
                        amount={amount}
                        currency={currency}
                        description={description}
                        customer={customer}
                        onSuccess={handleSuccess}
                        onError={handleError}
                        hideButton={true}
                    />
                </div>

                <div className="mt-4 text-sm text-center text-gray-500">
                    <p>Your payment is secured using industry-standard encryption.</p>
                    <button
                        onClick={onClose}
                        className="mt-4 px-6 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-md"
                    >
                        Cancel Payment
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default PaymentModal; 